import React from 'react';
import classes from "./style.module.scss";
import Button from '../../component/Button';
import { useNavigate } from 'react-router-dom';
import { Images } from '../../assets';

const Success = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/auth/login');
  };

  return (
    <div className='flex items-center justify-center'>
      <div className={`${classes.successPage}`}>
        <img src={Images.successGif} className={`${classes.successGif}`}/>
        <p className={`${classes.successMessage} mb-5`}>SUCCESS!</p>
        <p className={`${classes.successText} mb-8`}>Your password has been successfully changed. Now you can proceed with logging in with your new password.</p>
        <Button text={"Login"} className={`w-[70%] mx-auto`} onClick={handleLogin} />
      </div>
    </div>
  );
}

export default Success;
